import React from 'react';
import { observer, inject } from 'mobx-react';
import { Button, Row, Col, Form, Input, InputNumber, Icon } from 'antd';
const FormItem = Form.Item;
const { TextArea } = Input;
import styles from './DeviceConnect.less';
import io from 'socket.io-client';
import moment from 'moment';
import Alarm from '../../components/Alarm';
import Loading from '../../components/Loading';
import { formItemLayout } from '../../const/FormConst';
import * as Cookies from 'js-cookie';

const PUBLIC_KEY = {
  key: 'public-key',
  readJSON: () => {
    const string = localStorage.getItem(PUBLIC_KEY.key);
    const obj = string ? JSON.parse(string) : {};
    return obj;
  },
  set: (userId, value) => {
    const obj = PUBLIC_KEY.readJSON();
    obj[userId] = value;
    localStorage.setItem(PUBLIC_KEY.key, JSON.stringify(obj));
  },
  get: userId => {
    const obj = PUBLIC_KEY.readJSON();
    return obj[userId] || '';
  },
  remove: userId => {
    const obj = PUBLIC_KEY.readJSON();
    Reflect.deleteProperty(obj, userId);
    localStorage.setItem(PUBLIC_KEY.key, JSON.stringify(obj));
  }
};

let socketio;
@inject(
  'deviceInfoStore',
  'deviceInfoConnectStore',
  'deviceInfoDetailStore',
  'globalStore',
  'loginStore'
)
@observer
class Tab5Component extends React.Component {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.counter = this.counter.bind(this);
    this.disconnect = this.disconnect.bind(this);
    this.existConnectedDo = this.existConnectedDo.bind(this);
    this.sshStatusSuccess = this.sshStatusSuccess.bind(this);
  }
  componentDidMount() {
    const token = Cookies.get('token');
    if (token) {
      socketio = io(`${window.location.host}?access_token=${token}`);
      socketio.on(
        `ssh-${this.props.deviceInfoStore.deviceId}-${
          this.props.loginStore.userId
        }`,
        item => {
          if (item.status + '' === '0') {
            this.props.globalStore.showAlarm('连接失败');
            this.props.globalStore.loadingStatus = false;
            socketio.emit(
              'unsubscribe',
              {
                ...this.props.deviceInfoConnectStore.topic,
                userId: this.props.loginStore.userId,
                deviceId: this.props.deviceInfoStore.deviceId
              },
              data => {}
            );
          }
          if (item.step === 4 && item.status === 1 && item.jsonData) {
            const newJsonArr = item.jsonData.split(' ');
            const isPort = val => /^[0-9]*$/.test(val);
            this.props.deviceInfoConnectStore.port = newJsonArr.find(a =>
              isPort(a)
            );
            this.props.deviceInfoConnectStore.ip = item.jsonData.substring(17);
            this.counter(
              moment().add(
                this.props.deviceInfoConnectStore.formData.timeNumber,
                'minutes'
              ),
              moment()
            );
            this.props.globalStore.loadingStatus = false;
            this.props.globalStore.loadingTip = '';
          }
        }
      );
      this.getDefaultStatus();
    }
  }
  counter(endTime, startTime) {
    this.timer = setInterval(() => {
      const timeLeft = endTime.diff(moment(), 'seconds');
      const duration = moment().diff(startTime, 'seconds');
      this.props.deviceInfoConnectStore.duration = duration;
      this.props.deviceInfoConnectStore.timeLeft = timeLeft;
      if (timeLeft < 1) {
        clearInterval(this.timer);
        this.disconnect();
      }
    }, 1000);
  }
  disconnect() {
    this.props.deviceInfoConnectStore.sshClose(
      this.props.deviceInfoStore.deviceId
    );
    socketio.emit(
      'unsubscribe',
      {
        ...this.props.deviceInfoConnectStore.topic,
        userId: this.props.loginStore.userId,
        deviceId: this.props.deviceInfoStore.deviceId
      },
      data => {}
    );
    clearInterval(this.timer);
    this.props.deviceInfoConnectStore.ip = false;
    this.props.deviceInfoConnectStore.port = false;
    this.props.deviceInfoConnectStore.duration = false;
    this.props.deviceInfoConnectStore.timeLeft = false;
  }
  existConnectedDo(json) {
    this.props.deviceInfoConnectStore.ip = json.message.serverIp;
    this.props.deviceInfoConnectStore.port = json.message.listenPort;
    this.timer && clearInterval(this.timer);
    this.counter(
      moment(json.message.expireTime),
      moment(json.message.startTime)
    );
    this.props.globalStore.loadingStatus = false;
  }

  UnExistConnectedDo = async json => {
    let sshRequestData = await this.props.deviceInfoConnectStore.sshRequest(
      this.props.deviceInfoStore.deviceId,
      this.props.deviceInfoConnectStore.formData.key,
      this.props.deviceInfoConnectStore.formData.timeNumber
    );
    if (sshRequestData.code === 200) {
      socketio.emit(
        'unsubscribe',
        {
          ...this.props.deviceInfoConnectStore.topic,
          userId: this.props.loginStore.userId,
          deviceId: this.props.deviceInfoStore.deviceId
        },
        data => {}
      );
      socketio.emit(
        'subscribe',
        {
          ...this.props.deviceInfoConnectStore.topic,
          userId: this.props.loginStore.userId,
          deviceId: this.props.deviceInfoStore.deviceId
        },
        data => {}
      );
    } else {
      this.props.globalStore.showAlarm('连接失败');
      this.props.globalStore.loadingStatus = false;
      this.props.globalStore.loadingTip = '';
    }
  };

  sshStatusSuccess(sshStatusData) {
    let existConnected =
      sshStatusData.message &&
      sshStatusData.message.listenPort &&
      sshStatusData.message.serverIp;
    if (existConnected) {
      this.existConnectedDo(sshStatusData);
    } else {
      this.UnExistConnectedDo(sshStatusData);
    }
    this.props.globalStore.loadingTip = '';
  }
  getDefaultStatus = async () => {
    let sshStatusData = await this.props.deviceInfoConnectStore.sshStatus(
      this.props.deviceInfoStore.deviceId
    );
    if (sshStatusData.code === 200) {
      let existConnected =
        sshStatusData.message &&
        sshStatusData.message.listenPort &&
        sshStatusData.message.serverIp;
      if (existConnected) {
        this.existConnectedDo(sshStatusData);
      } else {
        this.props.globalStore.loadingStatus = false;
      }
    } else {
      this.props.globalStore.loadingStatus = false;
    }
  };

  onSubmit() {
    this.props.form.validateFields(async (error, value) => {
      if (!error) {
        this.props.deviceInfoConnectStore.formData = value;
        let sshStatusData = await this.props.deviceInfoConnectStore.sshStatus(
          this.props.deviceInfoStore.deviceId
        );
        if (sshStatusData.code === 200) {
          this.sshStatusSuccess(sshStatusData);
        } else {
          this.props.globalStore.showAlarm('连接失败');
          this.props.globalStore.loadingStatus = false;
          this.props.globalStore.loadingTip = '';
        }
      }
    });
  }

  render() {
    const {
      getFieldDecorator,
      getFieldValue,
      setFieldsValue
    } = this.props.form;
    const { duration, timeLeft } = this.props.deviceInfoConnectStore;
    const key = getFieldValue('key');
    const userId = this.props.loginStore.userId;
    return (
      <div className={styles.deviceInfoTab5}>
        <Row>
          <Col span={13} offset={1}>
            <Form onSubmit={this.onSubmit}>
              <FormItem {...formItemLayout} label="公钥">
                {getFieldDecorator('key', {
                  rules: [{ required: true, message: '请输入公钥!' }],
                  initialValue: PUBLIC_KEY.get(userId)
                })(
                  <TextArea
                    placeholder="请输入公钥"
                    autosize={{ minRows: 8, maxRows: 50 }}
                    onChange={e => PUBLIC_KEY.set(userId, e.target.value)}
                  />
                )}
                {!!key && (
                  <Icon
                    style={{
                      position: 'absolute',
                      bottom: 0,
                      right: 12,
                      cursor: 'pointer'
                    }}
                    onClick={() => {
                      PUBLIC_KEY.remove(userId);
                      setFieldsValue({ key: '' });
                    }}
                    type="close-circle"
                    theme="filled"
                  />
                )}
              </FormItem>
              <FormItem {...formItemLayout} label="保持连接时长">
                {getFieldDecorator('timeNumber', {
                  rules: [{ required: true, message: '请选择保持连接时长!' }],
                  initialValue: 120
                })(
                  <InputNumber
                    className={styles.inputNumbner}
                    min={0}
                    max={100000}
                  />
                )}
              </FormItem>
            </Form>
            <Row>
              <Col span={5} offset={8}>
                <Button
                  className={styles.connectBtn}
                  type="primary"
                  disabled={
                    (!this.props.deviceInfoDetailStore.deviceDetail[
                      'online_status'
                    ] &&
                      this.props.deviceInfoDetailStore.deviceDetail[
                        'online_status'
                      ] !== '0') ||
                    (this.props.deviceInfoConnectStore.ip &&
                      this.props.deviceInfoConnectStore.port)
                  }
                  onClick={this.onSubmit}
                >
                  连接
                </Button>
              </Col>
              <Col span={5}>
                <Button onClick={this.disconnect} className={styles.connectBtn}>
                  关闭
                </Button>
              </Col>
            </Row>
            <Alarm />
            {this.props.deviceInfoConnectStore.ip && (
              <div className={styles.afterConnectContainer}>
                <Row>
                  <Col span={4} offset={11}>
                    IP:
                  </Col>
                  <Col span={9}>
                    {this.props.deviceInfoConnectStore.ip || '--'}
                  </Col>
                </Row>
                <Row>
                  <Col span={4} offset={11}>
                    端口:
                  </Col>
                  <Col span={9}>
                    {this.props.deviceInfoConnectStore.port || '--'}
                  </Col>
                </Row>
              </div>
            )}
          </Col>
          <Col span={3} offset={4} className={styles.text}>
            <p>状态:</p>
            <p>已连接时长:</p>
            <p>距离自动关闭时长:</p>
          </Col>
          <Col span={2} offset={1} className={styles.textValue}>
            <p>{this.props.deviceInfoConnectStore.ip ? '已连接' : '未开启'}</p>
            <p>
              {duration
                ? duration < 60
                  ? `${duration}秒`
                  : `${Number.parseInt(duration / 60)}分钟`
                : '--'}
            </p>
            <p>
              {timeLeft
                ? timeLeft > 60
                  ? `${Number.parseInt(timeLeft / 60)}分钟`
                  : `${timeLeft}秒`
                : '--'}
            </p>
          </Col>
        </Row>
        <Loading />
      </div>
    );
  }
}
const Tab5 = Form.create()(Tab5Component);
export default Tab5;



// WEBPACK FOOTER //
// ./src/components/DeviceInfo/DeviceConnect.js